import { render, staticRenderFns } from "./RealizedGainLossLayout.vue?vue&type=template&id=6bdcef3a&scoped=true&"
import script from "./RealizedGainLossLayout.vue?vue&type=script&lang=js&"
export * from "./RealizedGainLossLayout.vue?vue&type=script&lang=js&"
import style0 from "./RealizedGainLossLayout.vue?vue&type=style&index=0&id=6bdcef3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdcef3a",
  null
  
)

component.options.__file = "RealizedGainLossLayout.vue"
export default component.exports